import { useEffect, useState } from 'react';

/**
 * Plan 040: the per-browser One-click choice (plan 012), shared by the ticket and the phone bar so a tap on the phone
 * buys exactly when the ticket's switch says buys send at once.
 */
const KEY = 'ct.oneClick', EVENT = 'ct-one-click';
// On unless this browser switched it off (plan 048): a new browser or a new address must not start by opening the order sheet
// on a phone tap.
const read = () => { try { return localStorage.getItem(KEY) !== '0'; } catch { return true; } };

export function useOneClick(): [boolean, (on: boolean) => void] {
  const [on, setOn] = useState(read);
  useEffect(() => {
    const sync = () => setOn(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener('storage', sync); };
  }, []);
  const choose = (next: boolean) => {
    try { localStorage.setItem(KEY, next ? '1' : '0'); } catch { /* storage unavailable: this page only */ }
    setOn(next); window.dispatchEvent(new Event(EVENT));
  };
  return [on, choose];
}
